import axios from 'axios';
const apiAxios = axios.create();
const defaultConfig = {
  type: 'get',
  dataType: 'json',
  timeout: 3000,
  contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
  withCredentials: true,
};
class RequestError extends Error {
  constructor(message, detail) {
    super(message);
    this.detail = detail;
  }
}
function request(option) {
  option = option || {};
  if (option.success) {
    delete option.success;
    console.warn('不支持success回调');
  }
  if (option.error) {
    delete option.error;
    console.warn('不支持error回调');
  }
  const transformResponse =
    option.transformResponse ||
    function (res) {
      return res;
    };
  delete option.transformResponse;
  const config = Object.assign({}, defaultConfig, option);
  config.method = config.type;
  config.headers = config.headers || {};
  if (config.contentType) {
    Object.assign(config.headers, { 'Content-Type': config.contentType });
  }

  if (config.method === 'get') {
    config.params = config.data;
    delete config.data;
  }
  //原因参考： https://learn.jquery.com/ajax/jquery-ajax-methods/
  //https://blog.csdn.net/gumuyan_/article/details/80269410

  return apiAxios
    .request(config)
    .then((res) => {
      if (res.status === 200) {
        const data = transformResponse(res.data);
        const detail = JSON.stringify({ config, data });
        if (data && data.returncode === 0) {
          if (data.result) {
            return data.result;
          }
          console.error('data.result为空：', detail);
        } else {
          const error = new RequestError(
            (data && data.message) || '服务端错误',
            detail,
          );
          return Promise.reject(error);
        }
      }
    })
    .catch((error) => {
      const detail = JSON.stringify(error);
      console.error(error);
      return Promise.reject(
        new RequestError(error.message || '网络请求错误', detail),
      );
    });
}

export { request, RequestError };
